import { Popover, PopoverProps, styled } from '@material-ui/core'
import { ReactNode } from 'react'

const ArrowStyle = styled('span')({
  top: '-12px',
  zIndex: 1,
  width: 12,
  right: 20,
  transform: 'translate(50%)',
  height: 12,
  content: "''",
  position: 'absolute',
  borderColor: 'transparent transparent #ffffff transparent',
  borderWidth: '5px',
  borderStyle: 'solid',
})

const PopOverStyle = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-elevation8': {
    boxShadow: theme.shadows[2],
    borderRadius: '0.5rem',
  },
  '& .MuiPopover-paper': {
    overflowY: 'initial',
    overflowX: 'initial',
    padding: '0.3rem',
  },
}))

interface MenuPopoverProps extends PopoverProps {
  children: ReactNode
  arrow?: boolean
}

const MenuPopover = ({ children, arrow, ...props }: MenuPopoverProps) => {
  return (
    <PopOverStyle
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      {...props}
    >
      {arrow && <ArrowStyle className="arrow" />}
      {children}
    </PopOverStyle>
  )
}

export default MenuPopover
